import BaseComponent from 'components/pages/Dashboard';
import { getIncomes } from 'domains/api/incomes';
import { getMonthlyTotalAssets } from 'domains/api/monthly_total_assets';
import { getOutgos } from 'domains/api/outgos';
import { resetCurrentUser } from 'domains/current_user';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Income, MonthlyTotalAsset, Outgo } from 'types';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const [incomes, setIncomes] = useState<Income[]>([]);
  const [isLoadingIncomes, setIsLoadingIncomes] = useState(false);
  useEffect(() => {
    setIsLoadingIncomes(true);
    void getIncomes()
      .then((response) => {
        setIncomes(response.incomes);
        setIsLoadingIncomes(false);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  }, [navigate]);

  const [outgos, setOutgos] = useState<Outgo[]>([]);
  const [isLoadingOutgos, setIsLoadingOutgos] = useState(false);
  useEffect(() => {
    setIsLoadingOutgos(true);
    void getOutgos()
      .then((response) => {
        setOutgos(response.outgos);
        setIsLoadingOutgos(false);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  }, [navigate]);

  const [monthlyTotalAssets, setMonthlyTotalAssets] = useState<
    MonthlyTotalAsset[]
  >([]);
  const [isLoadingTotalAssets, setIsLoadingTotalAssets] = useState(false);
  useEffect(() => {
    setIsLoadingTotalAssets(true);
    void getMonthlyTotalAssets()
      .then((response) => {
        setMonthlyTotalAssets(response.monthly_total_assets);
        setIsLoadingTotalAssets(false);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  }, [navigate]);

  return (
    <BaseComponent
      incomes={incomes}
      outgos={outgos}
      monthlyTotalAssets={monthlyTotalAssets}
      isLoadingIncomes={isLoadingIncomes}
      isLoadingOutgos={isLoadingOutgos}
      isLoadingTotalAssets={isLoadingTotalAssets}
    />
  );
};

export default Dashboard;
